import React from 'react';

import { UserRole } from '@appUtils/tripConverter';
import UserRoleList from '../UserRoleList';

const Pilots = () => <UserRoleList role={UserRole.PILOT} withActions />;

export default Pilots;
